import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import axios from "axios";
import {
  DocumentCollectionApi,
  GetDocumentResponse,
  QineticDocumentTypeEnum,
  SendDocumentByTypeDocumentTypeEnum,
} from "../../orchestrator-api-client";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

interface SubmitDocumentsArgs {
  data: Record<string, File | null>;
  type: SendDocumentByTypeDocumentTypeEnum;
}

export const submitIncomeDocumentation = createAsyncThunk<
  void,
  SubmitDocumentsArgs,
  ThunkApi
>(
  "submitIncomeDocumentation",
  async (submitDocumentsArgs, { getState, rejectWithValue }) => {
    try {
      const { data, type } = submitDocumentsArgs;

      const { documents } =
        (type === SendDocumentByTypeDocumentTypeEnum.Payrolls
          ? getState().loan.payrolls
          : getState().loan.accountStatement) || {};

      const mappedDocuments = documents?.map(
        (document: GetDocumentResponse) => {
          const id = document.id!;
          const code = document.code!;
          const fileExtension = data[code]?.name
            ?.split(".")
            ?.pop()
            ?.toUpperCase()!;
          const preSignedUrl = document.preSignedUrlMap![fileExtension];
          const file = data[code];

          return { file, preSignedUrl, id, code, fileExtension };
        },
      );

      const promises = mappedDocuments
        ?.filter((docs) => docs.fileExtension)
        .map(({ file, preSignedUrl }) => {
          return axios.put(preSignedUrl, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": file!.type,
            },
          });
        });

      await Promise.all(promises!);

      await new DocumentCollectionApi().sendDocumentByType(type, {
        documents: mappedDocuments!
          .filter((documents) => documents.fileExtension)
          .map((document) => ({
            id: String(document.id),
            code: document.code,
            type: document.fileExtension as QineticDocumentTypeEnum,
          }))!,
      });
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Salvataggio documenti reddituali",
        description:
          "Non siamo riusciti a salvare i tuoi documenti reddituali.\n Puoi riprovare o contattare il supporto",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
